import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import './responsive.css'
import { DndProvider } from "react-dnd";
import { MultiBackend } from 'react-dnd-multi-backend';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import { usePreview } from 'react-dnd-preview'


const MyPreview = () => {
  const preview = usePreview();
  if (!preview.display) {
    return null
  }
  const { item, style } = preview;
  return <div className="item_list__item" style={style}><img src={item[0].image} /></div>
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <DndProvider backend={MultiBackend} options={HTML5toTouch}>
    <App />
    <MyPreview />
  </DndProvider>
)


